// extracted by mini-css-extract-plugin
module.exports = {"contacts":"style_contacts__HKE9n","contacts_item":"style_contacts_item__2zsWk"};